var _defs, _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArctic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "arctic",
    xmlns: "http://www.w3.org/2000/svg",
    width: 65.679,
    height: 15,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#730844}\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    className: "cls-1",
    d: "M368.113 297.764a.416.416 0 0 1-.416-.416v-8.622A1.724 1.724 0 0 1 369.42 287h5.688a.434.434 0 0 1 .433.433v.626a.434.434 0 0 1-.433.433h-3.36a.6.6 0 0 0-.6.6v8.254a.416.416 0 0 1-.416.416z",
    transform: "translate(-351.436 -282.764)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_28",
    "data-name": "Rectangle 28",
    className: "cls-1",
    d: "M1.324 0h.8a1.324 1.324 0 0 1 1.327 1.324v8.112a1.324 1.324 0 0 1-1.324 1.324h-.8A1.323 1.323 0 0 1 0 9.437V1.324A1.324 1.324 0 0 1 1.324 0z",
    transform: "translate(49.259 4.24)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    className: "cls-1",
    d: "M497.079 297.763a4.34 4.34 0 0 1-4.335-4.335v-2.088a4.34 4.34 0 0 1 4.335-4.34h5.385a.434.434 0 0 1 .433.433v.626a.433.433 0 0 1-.433.433h-4.117a2.154 2.154 0 0 0-2.151 2.152v3.473a2.154 2.154 0 0 0 2.151 2.151h4.117a.434.434 0 0 1 .433.433v.625a.434.434 0 0 1-.433.433z",
    transform: "translate(-437.218 -282.764)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    className: "cls-1",
    d: "M400.945 297.763a4.34 4.34 0 0 1-4.335-4.335v-2.088a4.34 4.34 0 0 1 4.335-4.34h5.384a.434.434 0 0 1 .433.433v.626a.433.433 0 0 1-.433.433h-4.117a2.154 2.154 0 0 0-2.151 2.152v3.473a2.154 2.154 0 0 0 2.151 2.151h4.117a.434.434 0 0 1 .433.433v.625a.434.434 0 0 1-.433.433z",
    transform: "translate(-371.27 -282.764)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    className: "cls-1",
    d: "M326.074 297.764a.416.416 0 0 1-.416-.416V289.1a.6.6 0 0 0-.6-.6h-3.546a2.154 2.154 0 0 0-2.151 2.151v3.464a2.154 2.154 0 0 0 2.151 2.151h1.32a.434.434 0 0 1 .433.433v.625a.434.434 0 0 1-.433.433h-2.587a4.34 4.34 0 0 1-4.335-4.335v-2.088a4.34 4.34 0 0 1 4.336-4.334h7.131a1.734 1.734 0 0 1 1.732 1.732v8.612a.416.416 0 0 1-.416.416z",
    transform: "translate(-315.911 -282.764)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    className: "cls-1",
    d: "M444.591 287.009h-1.3a2.154 2.154 0 0 1-2.152-2.151v-5.624h3.93a.434.434 0 0 0 .434-.433v-.626a.434.434 0 0 0-.434-.433h-3.93v-3.825a.416.416 0 0 0-.416-.415H438.1a.416.416 0 0 0-.416.415v10.41a4.339 4.339 0 0 0 4.331 4.173h2.571a.434.434 0 0 0 .433-.434v-.624a.434.434 0 0 0-.433-.433",
    transform: "translate(-399.448 -273.501)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArctic);
export default __webpack_public_path__ + "static/media/arctic.eb1ea8e49057b8bdd65c744e176d384a.svg";
export { ForwardRef as ReactComponent };